export const SectionHeader = ({ icon: Icon, title, subtitle }) => (
  <div className="flex items-start gap-3 mb-4">
    <div className="h-9 w-9 rounded-md bg-af-subtle border border-af flex items-center justify-center shrink-0">
      <Icon className="h-4 w-4 text-terracotta" />
    </div>
    <div>
      <h3 className="font-display font-bold text-lg">{title}</h3>
      {subtitle && <p className="text-xs text-af-muted mt-0.5">{subtitle}</p>}
    </div>
  </div>
);
